import { useCallback, useState } from 'react';
import { connect } from 'react-redux';

import { checkObjectAddressMatchFns } from 'KnmErpPackage/MainModule/common/checkObjectAddressMatchFns';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { NotMatchingFnsFieldTypesEnum } from 'KnmPackage/MainModule/enums/NotMatchingFnsFieldTypesEnum';
import { IKnmForm } from 'KnmPackage/MainModule/interfaces/IKnmForm';
import { getKnmFormRef } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { ConfirmModal } from 'UIPackage/MainModule/components/ConfirmModal';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { ReplaceAlert } from './ReplaceAlert';

const replaceFnsDataFieldsMap = {
  [NotMatchingFnsFieldTypesEnum.ORGANIZATION_NAME]: 'Наименования проверяемого лица',
  [NotMatchingFnsFieldTypesEnum.OBJECT_LEGAL_ADDRESS]: 'Адреса местонахождения объекта КНМ',
};

interface IKnmErpSubjectReplaceDataProps {
  className?: string;
  isReplaceAlertsVisible: boolean;
  notMatchingFnsFields: NotMatchingFnsFieldTypesEnum[] | undefined;
  objects: IKnmForm['objects'];
  organizationName: IKnmForm['organizationName'];
  registryLegalAddressFns: string | undefined;
  registryOrganizationNameFns: string | undefined;
  onHideButtonClick: () => void;
  onShowButtonClick: () => void;
}

interface IKnmErpSubjectReplaceDataStoreProps {
  formRef: IKnmFormRef | undefined;
}

const KnmErpSubjectReplaceDataWithoutStore = ({
  className = '',
  isReplaceAlertsVisible,
  notMatchingFnsFields,
  objects,
  organizationName,
  registryLegalAddressFns,
  registryOrganizationNameFns,
  onHideButtonClick,
  onShowButtonClick,
  formRef,
}: IKnmErpSubjectReplaceDataProps & IKnmErpSubjectReplaceDataStoreProps) => {
  const [isReplaceDataModalVisible, setIsReplaceDataModalVisible] = useState(false);
  const openReplaceDataModal = useCallback(() => setIsReplaceDataModalVisible(true), []);
  const closeReplaceDataModal = useCallback(() => setIsReplaceDataModalVisible(false), []);

  const isOrganizationNameFieldReplacing = Boolean(
    registryOrganizationNameFns && organizationName !== registryOrganizationNameFns,
  );

  const handleReplaceDataModalApply = useCallback(() => {
    if (isOrganizationNameFieldReplacing) {
      formRef?.current.change('organizationName', registryOrganizationNameFns);
    }

    if (registryLegalAddressFns) {
      objects?.forEach((formObject, index) => {
        if (checkObjectAddressMatchFns(formObject, registryLegalAddressFns)) {
          const addressFieldName = `objects[${index}].address` as keyof IKnmForm;

          formRef?.current.change(addressFieldName, registryLegalAddressFns);
        }
      });
    }
  }, [formRef, isOrganizationNameFieldReplacing, objects, registryLegalAddressFns, registryOrganizationNameFns]);

  return (
    <>
      <ReplaceAlert
        className={className}
        active={isReplaceAlertsVisible}
        text={`Сведения о проверяемом лице не соответствуют данным в ФНС.${
          isReplaceAlertsVisible ? '' : '  Заменить значения сведениями из ЕГРЮЛ/ЕГРИП?'
        }`}
        onHideButtonClick={onHideButtonClick}
        onReplaceButtonClick={openReplaceDataModal}
        onShowButtonClick={onShowButtonClick}
      />

      <ConfirmModal
        visible={isReplaceDataModalVisible}
        title="Подтверждение"
        applyButtonText="Изменить"
        cancelButtonText="Отменить"
        onApply={handleReplaceDataModalApply}
        onClose={closeReplaceDataModal}
      >
        <>
          Вы осуществляете изменение:
          <ul>
            {notMatchingFnsFields?.map((notMatchingFnsField, index) => (
              <li key={index}>{replaceFnsDataFieldsMap[notMatchingFnsField]}</li>
            ))}
          </ul>
          Изменить?
        </>
      </ConfirmModal>
    </>
  );
};

const mapStateToProps = (state: IRootState): IKnmErpSubjectReplaceDataStoreProps => ({
  formRef: getKnmFormRef(state),
});

export const KnmErpSubjectReplaceData = connect(mapStateToProps)(KnmErpSubjectReplaceDataWithoutStore);
